import {
  ParagraphCtaBlock,
  ParagraphDivider,
  ParagraphDownloads,
  ParagraphFaqItems,
  ParagraphHighlightIconText,
  ParagraphImage,
  ParagraphInfographicWrapper,
  ParagraphText,
  ParagraphTextImage,
  ParagraphVideo,
  ParagraphWebform,
  ParagraphParticipantsList,
  ParagraphCatalog,
  ParagraphArticleOverview,
  ParagraphRecentArticles,
  ParagraphPressOverview,
  ParagraphMaterialTypes,
  ParagraphHelpPagesAdministration,
  ParagraphHelpPagesGeneral,
  ParagraphHelpPagesTariffs,
  ParagraphHelpPagesPPWR,
  ParagraphUSPWrapper,
  ParagraphWasteCostCalculator,
  ParagraphCustomHTML,
} from '../implementations';

const mappers = {
  cta_block: ParagraphCtaBlock,
  divider: ParagraphDivider,
  downloads: ParagraphDownloads,
  faq_items: ParagraphFaqItems,
  highlight_icon_text: ParagraphHighlightIconText,
  image: ParagraphImage,
  infographic_wrapper: ParagraphInfographicWrapper,
  participants_list: ParagraphParticipantsList,
  text: ParagraphText,
  text_image: ParagraphTextImage,
  video: ParagraphVideo,
  webform: ParagraphWebform,
  catalog: ParagraphCatalog,
  article_overview: ParagraphArticleOverview,
  recent_articles: ParagraphRecentArticles,
  press_overview: ParagraphPressOverview,
  material_types: ParagraphMaterialTypes,
  help_pages_administration: ParagraphHelpPagesAdministration,
  help_pages_general: ParagraphHelpPagesGeneral,
  help_pages_tariffs: ParagraphHelpPagesTariffs,
  help_pages_ppwr: ParagraphHelpPagesPPWR,
  usp_wrapper: ParagraphUSPWrapper,
  waste_cost_calculator: ParagraphWasteCostCalculator,
  custom_html: ParagraphCustomHTML,
};

export default mappers;
